module.exports = __webpack_public_path__ + "static/web_baobab-min-55aba296bcb5e529c48164e127ca7534.png";